import {toast} from "react-toastify";
import React from "react";
import {toastAsError} from "@utilities/toastAsError";

// https://stackoverflow.com/questions/62900424/toastify-reactjs-adding-a-link
export function customToastWithLink(subject: string, URI: string): React.ReactNode {
    return <div>
        <p>Export <i className="font-bold">{subject}</i> eseguito, il file &egrave; stato salvato nello Spool.</p>
        <p>Puoi <a className="text-blue-500 font-bold hover:underline" href={URI}>scaricare qui il file!</a></p>
    </div>
}
export function customToastWithLink4Stampa(subject: string, URI: string): React.ReactNode {
    return <div>
        <p>Stampa <i className="font-bold">{subject}</i> eseguita, il file &egrave; stato salvato nello Spool.</p>
        <p>Puoi <a className="text-blue-500 font-bold hover:underline" target={'_blank'} href={URI}>scaricare qui il file!</a></p>
    </div>
}

type CustomToastWithURI = (subject: string, URI: string) => React.ReactNode;
type GetTriggerFn = (URI: object, useCache: boolean) => Promise<any>;
export const export2excel = (exportTrigger: GetTriggerFn, filter: object, subject: string, customToast: CustomToastWithURI = customToastWithLink) => {
    exportTrigger({...filter, mode: 'export2excel'}, false).then((res) => {
        if (res && res.isSuccess) {
            const URI = res.data && res.data.URI ? res.data.URI : '???';
            toast.success(customToast(subject, URI));
        } else if (res.isError) {
            if ('data' in res.error) {
                // @ts-ignore
                const message = res.error.data.message;
                toastAsError(message);
            } else
                toastAsError("Errore generico!");
        }
    });
}
